// CoachDrawer.tsx - the "See the full debrief" trigger (S22). Opens the deep coaching debrief in the
// SHARED glossary popover (mockup: dg-see reused the same .pop/.scrim as the term glossary, injecting the
// debrief title/body/example). The button is the whole component; the bottom-sheet is <GlossaryProvider>'s.
import { useGlossary } from '../components/Glossary';
import type { DebriefContent } from './types';

export function CoachDrawer({ debrief }: { debrief: DebriefContent }) {
  const { openContent } = useGlossary();
  return (
    <button
      type="button"
      className="dg-see"
      onClick={() =>
        openContent({
          title: debrief.title,
          description: debrief.body,
          exampleLabel: debrief.example.label,
          example: debrief.example.text,
        })
      }
    >
      See the full debrief
    </button>
  );
}
